AttachmentHelpers = require('./helpers')
template = require 'app/scripts/views/templates/edit_attachment'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
Promise = require 'bluebird'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
PluginModelSerializer = require 'app/scripts/views/internal/plugins/plugin-model-serializer'
t = require('app/scripts/views/internal/teacup-with-helpers')('edit_attachment')
{ sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ DropboxPluginId } = require 'app/scripts/data/dropbox'

saveAttachmentTemplate = t.renderable ( plugins ) ->
  t.div '.save-attachment'
  plugins?.map (plugin, i) ->
    t.div '.js-save-attachment-button.save-attachment-section',
      'data-index': i, ->
        t.div '.save-attachment-thumbnail',
          style: t.stylify
            'background-image': if plugin.icon? then t.urlify(plugin.icon)
        t.span '.save-attachment-label', ->
          t.format 'save-attachment', pluginName: plugin.name

module.exports = class AttachmentEditPopover extends View
  viewTitleKey: 'edit attachment'

  events:
    'click .js-edit-attachment': 'submit'
    'click .js-save-attachment-button': 'executeActionCallback'

  submit: (e) =>
    Util.stop(e)

    { newName, nameShortened } = AttachmentHelpers.stripAndShortenName(
      @$('.js-attachment-name').val()
    )
    if nameShortened
      @$('.js-attachment-name').val(newName)

    newUrl = @$('.js-attachment-url').val()
    type = @model.getServiceKey()
    oldName = @model.get('name')
    oldUrl = @model.get('url')

    { newName, newUrl, canUpdate } = AttachmentHelpers.validateUrlAndName(
      newUrl, newName, oldUrl, oldName, type
    )

    if canUpdate
      if type == 'other'
        @model.update({ url: newUrl, name: newName })
      else
        @model.update('name', newName)
      PopOver.hide()

  executeActionCallback: (e) ->
    Util.stop(e)
    index = parseInt(@$(e.currentTarget).attr('data-index'), 10)
    if @pluginSaveActions[index]?.idPlugin?
      sendPluginUIEvent(@pluginSaveActions[index].idPlugin, {
        action: 'clicked'
        actionSubject: 'button'
        source: 'cardDetailScreen'
        actionSubjectId: 'saveAttachmentButton'
        objectType: 'powerUp'
        objectId: @pluginSaveActions[index].idPlugin
      })
    if @pluginSaveActions[index]?.callback?
      @pluginSaveActions[index].callback
        el: e.currentTarget

  render: ->
    data = {}
    data.name = @model.get('name')
    data.url = @model.get('url')
    data.serviceKey = @model.getServiceKey()

    card = @model.getCard()
    board = card.getBoard()

    @$el.html template(data)

    renderSaveAttachment = featureFlagClient.get('ecosystem.save-attachment-capability', 'none') == 'all'
    dropboxSaveAttachment = featureFlagClient.get('ecosystem.save-attachment-capability', 'none') == 'dropbox'

    if @model.get('isUpload') && (renderSaveAttachment || (dropboxSaveAttachment && board.isPluginEnabled(DropboxPluginId)))
      Promise.try =>
        PluginRunner.all
          command: 'save-attachment'
          board: board
          card: card
          options: PluginModelSerializer.attachment(@model)
          plugin: DropboxPluginId if dropboxSaveAttachment
      .then (saveAttachment) =>
        @pluginSaveActions = saveAttachment.filter(pluginValidators.isValidSaveAttachment)
          .map (action) =>
            callback: action.callback,
            idPlugin: action.idPlugin
        if @pluginSaveActions.length > 0
          plugins = @pluginSaveActions
            .map (data) =>
              PluginIOCache.fromId(data.idPlugin)
            .map (plugin) =>
              if pluginValidators.isValidUrlForImage(plugin?.icon?.url)
                icon: plugin.icon.url,
                name: plugin.name
              else
                name: plugin.name
          $saveAttachment = @$('.save-attachment-container')
          $saveAttachment.append saveAttachmentTemplate(plugins)
          $saveAttachment.show()

    @
